import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import reportWebVitals from './reportWebVitals';
import rootReducer from './app/reducers/rootReducer';

import './index.scss';

import { ServicesProvider } from './app/contexts/ServicesContext';
import { StorageService } from './app/common-services/Storage/StorageService';
import { HttpService } from './app/common-services/Http/HttpService';

import { App } from './App';

const store = createStore(rootReducer, applyMiddleware(thunk));

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ServicesProvider httpService={new HttpService(new StorageService())}>
        <App />
      </ServicesProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
